import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { MatDialog } from '@angular/material/dialog';
import { ToastService } from './toast.service';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  constructor(
    private toast: ToastService,
    private httpClient: HttpClient,
    private dialog: MatDialog
  ) { }

  snackBarMessage(message: any, _action?: any) {
    this.toast.show(String(message));
  }

  toastMessage(message: any) {
    this.toast.show(String(message));
  }

  openDialog(componentName: any, height: any, width: any, dataModel: any) {
    return this.dialog.open(componentName, {
      width: width,
      height: height,
      data: dataModel,
      disableClose: true,
    });
  }

}
